import { DateTime } from 'luxon'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faUser } from '@fortawesome/pro-solid-svg-icons'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useSelector from '@hooks/useSelector'
import { generateUrls } from '@hooks/useCampaign'

import { combineAgentNames } from '@functions/agent'

import type { CampaignModel } from '@domain-group/realhub-backend-api-types'

type AuctionListItemProps = {
  agencyIdParam: string | undefined,
  campaign: CampaignModel,
}

const AuctionListItem = (props: AuctionListItemProps) => {
  const {
    campaign,
    campaign: {
      agent_ids,
      auction_date,
      title,
    },
    agencyIdParam,
  } = props

  const date = DateTime.fromISO(auction_date!, { setZone: true })
  const formattedTime = date.toFormat('h:mm a')

  const agents = useSelector(reduxState => reduxState.entities.agents)

  const {
    campaignEditDetailsUrl,
  } = generateUrls(campaign, { prefixRoute: `agency/dashboard/agencies/${agencyIdParam}/auctions` })

  return (
    <DashboardModuleListItem
      href={campaignEditDetailsUrl}
      secondaryText={(
        <>
          <FontAwesomeIcon icon={faUser} /> {combineAgentNames({ agentIds: agent_ids, agents, joiningWord: '&' })}
        </>
      )}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {formattedTime} <FontAwesomeIcon icon={faCalendarAlt} />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default AuctionListItem
